function getIonContentTarget(content) {
    return content?.$el || content || null;
}

async function scrollContentToTop(content, duration = 0) {
    const target = getIonContentTarget(content);
    if (!target) return;

    if (typeof target.scrollToTop === "function") {
        await target.scrollToTop(duration);
        return;
    }

    const scrollElement = await target.getScrollElement?.();
    if (scrollElement) {
        scrollElement.scrollTop = 0;
        return;
    }

    if (typeof target.scrollTo === "function") {
        target.scrollTo({ top: 0, left: 0, behavior: duration > 0 ? "smooth" : "auto" });
        return;
    }

    if ("scrollTop" in target) {
        target.scrollTop = 0;
    }
}

export async function resetPageScroll(vm, duration = 0) {
    if (typeof document === "undefined") return;

    const content =
        vm?.$refs?.contentScroll ||
        vm?.$el?.querySelector?.("ion-content") ||
        document.querySelector("ion-router-outlet .ion-page:not(.ion-page-hidden) ion-content") ||
        document.querySelector("ion-content");

    await scrollContentToTop(content, duration);
}
